import { Component, OnInit } from '@angular/core';
import { ModalController, LoadingController, AlertController, NavParams } from '@ionic/angular';
import { APIService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { ObserverService } from '../../services/observer.service';

@Component({
    selector: 'app-organisation-filter',
    templateUrl: './organisation-filter.page.html',
    styleUrls: ['./organisation-filter.page.scss'],
})

export class OrganisationFilterPage implements OnInit {

    online = true;
    spinner = null;
    loading_spinner = null;
    loading = false;
    filter_params = {};
    tags = [];
    categories = [];

    category_select_options: any = { header: 'Category' };
    tag_select_options: any = { header: 'Tag' };
    website_status_select_options: any = { header: 'Website status' };
    has_credit_limit_select_options: any = { header: 'Has credit limit' };
    has_amount_owing_select_options: any = { header: 'Has amount owing' };
    has_exceeded_credit_limit_select_options: any = { header: 'Has exceeded credit limit' };

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public navParams: NavParams,
        public loadingController: LoadingController,
        private observerService: ObserverService,
        private router: Router,
        private authService: AuthService,
        private apiService: APIService,
    ) { }

    ngOnInit() {

        if(this.navParams.get('website_status')) {
            this.filter_params['website_status'] = this.navParams.get('website_status');
        }

        if(this.navParams.get('tag_id')) {
            this.filter_params['tag_id'] = this.navParams.get('tag_id');
        }

        if(this.navParams.get('category_id')) {
            this.filter_params['category_id'] = this.navParams.get('category_id');
        }

        if(this.navParams.get('has_credit_limit') != undefined) {
            this.filter_params['has_credit_limit'] = this.navParams.get('has_credit_limit');
        }

        if(this.navParams.get('has_amount_owing') != undefined) {
            this.filter_params['has_amount_owing'] = this.navParams.get('has_amount_owing');
        }

        if(this.navParams.get('has_exceeded_credit_limit') != undefined) {
            this.filter_params['has_exceeded_credit_limit'] = this.navParams.get('has_exceeded_credit_limit');
        }

        this.loadData().then(() => { }).catch(() => { });

        this.observerService.subscribe('network_status_changed|order_filter_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Problem", "Offline", "You must be online to filter organisations, please check your network connection and try again.");
                }
            }
        });

    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading tags").then(() => {
                this.loadOrganisationTags().then(() => {
                    this.loading_spinner.message = "Loading categories";
                    this.loadOrganisationCategories().then(() => {
                        this.loading_spinner.dismiss();
                        resolve();
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadOrganisationCategories() {
        return new Promise<void>((resolve, reject) => {
            this.categories = [];
            this.authService.isLoggedIn().then(() => {
                this.apiService.getOrganisationCategories().then((categories: []) => {
                    if(categories) {
                        this.appendCategories(categories, '').then(() => {
                            let category_found = false
                            for(let i = 0; i < this.categories.length; i++) {
                                if(this.categories[i].id == this.filter_params['category_id']) {
                                    category_found = true;
                                    break
                                }
                            }
                            if(!category_found) {
                                delete this.filter_params['category_id'];
                            }
                            resolve();
                        });
                    }
                })
                .catch((error) => {
                    if(error.status == 400) {
                        this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to retrieve a list of organisation categories.");
                    }
                    else if(error.status == 403) {
                        this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to view organisation categories.");
                    }
                    else if(error.status == 404 || error.status == 0) {
                        this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to retrieve a list of organisation categories at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    appendCategories(categories, previousCategories) {
        let promise = new Promise<void>((resolve) => {
            for(let i = 0; i < categories.length; i++) {
                let category = {};
                category['id'] = categories[i].id;
                category['title'] = previousCategories + categories[i].title;
                this.categories.push(category);
                if(categories[i].categories) {
                    this.appendCategories(categories[i].categories, category['title'] + ' > ');
                }
            }
            resolve();
        });
        return promise;
    }

    loadOrganisationTags() {
        return new Promise<void>((resolve, reject) => {
            this.tags = [];
            this.authService.isLoggedIn().then(() => {
                this.apiService.getOrganisationTags().then((tags: []) => {
                    if(tags) {
                        this.tags = tags;
                        let tag_found = false
                        for(let i = 0; i < this.tags.length; i++) {
                            if(this.tags[i].id == this.filter_params['tag_id']) {
                                tag_found = true;
                                break
                            }
                        }
                        if(!tag_found) {
                            delete this.filter_params['tag_id'];
                        }
                        this.tags.sort((a, b) => {
                            if(a.title < b.title) { return -1; }
                            if(a.title > b.title) { return 1; }
                            return 0;
                        });
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error.status == 400) {
                        this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to retrieve a list of organisation tags.");
                    } 
                    else if(error.status == 403) {
                        this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to view organisation tags.");
                    } 
                    else if(error.status == 404 || error.status == 0) {
                        this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to retrieve a list of organisation tags at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    filter() {
        this.modalController.dismiss(this.filter_params);
    }

    clearWebsiteStatus() {
        delete this.filter_params['website_status'];
    }

    clearTag() {
        delete this.filter_params['tag_id'];
    }

    clearCategory() {
        delete this.filter_params['category_id'];
    }

    clearHasCreditLimit() {
        delete this.filter_params['has_credit_limit'];
    }

    clearHasAmountOwing() {
        delete this.filter_params['has_amount_owing'];
    }

    clearHasExceededCreditLimit() {
        delete this.filter_params['has_exceeded_credit_limit'];
    }

    clearFilters() {
        this.presentSpinner("Clearing filters").then(() => {
            if(this.filter_params['website_status']) {
                delete this.filter_params["website_status"];
            }
            if(this.filter_params['tag_id']) {
                delete this.filter_params["tag_id"];
            }
            if(this.filter_params['category_id']) {
                delete this.filter_params["category_id"];
            }
            if('has_credit_limit' in this.filter_params) {
                delete this.filter_params["has_credit_limit"];
            }
            if('has_amount_owing' in this.filter_params) {
                delete this.filter_params["has_amount_owing"];
            }
            if('has_exceeded_credit_limit' in this.filter_params) {
                delete this.filter_params["has_exceeded_credit_limit"];
            }
            this.spinner.dismiss();
        });
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}
